import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";

const AssignReturnAssetPopup = ({ asset, onClose, onSave, users, mode }) => {
  const [assignedTo, setAssignedTo] = useState(null);
  const [actionDate, setActionDate] = useState(new Date());
  const [notes, setNotes] = useState("");
  const submitButtonRef = useRef(null);

  const userOptions = users.map((user) => ({
    value: user.id,
    label: `${user.name}`,
  }));

  useEffect(() => {
    if (mode === "Return" && asset) {
      // Prefill with assignment information for the "Return" mode
      setAssignedTo(asset.assigned_user_name || "Unassigned");
      setActionDate(new Date()); // Set default return date to today
      setNotes("");
    } else {
      // Reset fields for "Assign" mode
      setAssignedTo(null);
      setActionDate(new Date());
      setNotes("");
    }
  }, [mode, asset]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (mode === "Assign" && !assignedTo) {
      toast.error("Please select a user to assign the asset.");
      return;
    }

    const actionData = {
      assignedTo: assignedTo?.value || asset.assigned_to, // Use the existing assigned user for "Return"
      actionDate: actionDate ? actionDate.toISOString().split("T")[0] : null,
      notes,
      actionType: mode, // "Assign" or "Return"
    };

    try {
      // Call save action with actionData
      await onSave(actionData);
      if (submitButtonRef.current) submitButtonRef.current.click();
    } catch (error) {
      console.error(`Error ${mode.toLowerCase()}ing asset:`, error);
      toast.error(`Failed to ${mode.toLowerCase()} the asset. Please try again.`);
    }
  };

  return (
    <div id="assign_return_asset" className="modal custom-modal fade" role="dialog">
      <div className="modal-dialog modal-lg" style={{ margin: 0, position: "fixed", right: 0, height: "100vh", width: "50%" }}>
        <div className="modal-content h-100 d-flex flex-column">
          <form onSubmit={handleSubmit}>
            <div className="modal-header">
              <h5 className="modal-title">{mode === "Assign" ? "Assign Asset" : "Return Asset"}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={onClose}>
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body flex-grow-1 overflow-auto" style={{ maxHeight: "calc(100vh - 120px)" }}>
              
              {mode === "Return" && asset && (
                <div className="row mb-3" style={{ borderBottom: '1px solid #e0e0e0', paddingBottom: '10px', alignItems: 'center' }}>
                  <div className="col-md-3">
                    <label className="col-form-label">Assigned User</label>
                  </div>
                  <div className="col-md-9">
                    <div className="form-control-plaintext">{asset.assigned_user_name || "Unassigned"}</div>
                  </div>
                </div>
              )}

              {mode === "Return" && asset && (
                <>
                  <div className="row mb-3" style={{ borderBottom: '1px solid #e0e0e0', paddingBottom: '10px', alignItems: 'center' }}>
                    <div className="col-md-3">
                      <label className="col-form-label">Assigned By</label>
                    </div>
                    <div className="col-md-9">
                      <div className="form-control-plaintext">{asset.assigned_by_name || "N/A"}</div>
                    </div>
                  </div>

                  <div className="row mb-3" style={{ borderBottom: '1px solid #e0e0e0', paddingBottom: '10px', alignItems: 'center' }}>
                    <div className="col-md-3">
                      <label className="col-form-label">Assignment Date</label>
                    </div>
                    <div className="col-md-9">
                      <div className="form-control-plaintext">{asset.assignment_date ? new Date(asset.assignment_date).toLocaleDateString() : "N/A"}</div>
                    </div>
                  </div>
                </>
              )}

              {mode === "Assign" && (
                <div className="row mb-3" style={{ borderBottom: '1px solid #e0e0e0', paddingBottom: '10px', alignItems: 'center' }}>
                  <div className="col-md-3">
                    <label className="col-form-label">Assign To <span className="text-danger">*</span></label>
                  </div>
                  <div className="col-md-9">
                    <Select
                      options={userOptions}
                      value={assignedTo}
                      onChange={setAssignedTo}
                      placeholder="Select User"
                      className="flex-grow-1"
                    />
                  </div>
                </div>
              )}

              <div className="row mb-3" style={{ borderBottom: '1px solid #e0e0e0', paddingBottom: '10px', alignItems: 'center' }}>
                <div className="col-md-3">
                  <label className="col-form-label">{mode === "Assign" ? "Assignment Date" : "Return Date"} <span className="text-danger">*</span></label>
                </div>
                <div className="col-md-9">
                  <DatePicker
                    selected={actionDate instanceof Date && !isNaN(actionDate) ? actionDate : null}
                    onChange={(date) => setActionDate(date)}
                    className="form-control"
                    dateFormat="dd-MM-yyyy"
                  />
                </div>
              </div>

              <div className="row mb-3" style={{ borderBottom: '1px solid #e0e0e0', paddingBottom: '10px', alignItems: 'center' }}>
                <div className="col-md-3">
                  <label className="col-form-label">Notes</label>
                </div>
                <div className="col-md-9">
                  <textarea
                    className="form-control"
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    rows="3"
                    placeholder="Optional notes for action"
                  />
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={onClose}>
                Close
              </button>
              <button className="btn btn-primary submit-btn" type="submit">
                {mode === "Assign" ? "Assign Asset" : "Return Asset"}
              </button>
            </div>
          </form>
          <div style={{ display: "none" }}>
            <button ref={submitButtonRef} data-bs-dismiss="modal" aria-label="Close" type="reset">
              HiddenSubmit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignReturnAssetPopup;
